import { get } from 'lodash';

export const isListingOwner = (listing, userProfile) => {
  const accounts = get(userProfile, 'companyAccounts', []);
  // if this is org/permission dependent, so be it.  punt.
  return accounts && accounts.length > 0;
};

export const findPlacedBids = listing => get(listing, 'bids.mine');

export default {
  findPlacedBids,
  isListingOwner,
};



// WEBPACK FOOTER //
// ./src/types/models/listing.js